import { scaleTime, type ScaleTime } from 'd3-scale';
import { createContext } from 'react';

export const TimeseriesChartXScaleContext = createContext<{
  initialScale: ScaleTime<number, number>;
  currentScale: ScaleTime<number, number>;
}>({
  initialScale: scaleTime(),
  currentScale: scaleTime(),
});

TimeseriesChartXScaleContext['displayName'] = 'TimeseriesChartXScaleContext';
